import React from 'react';
import pt from 'prop-types';
import { Chip, ListItemButton, ListItemText } from '@metarouter-private/mr-mui';

const PRIMARY_TYPOGRAPHY_PROPS = { noWrap: true, variant: 'body1', fontWeight: 600 };

export default function CurrentOrgBanner({ name, switching, onSelect }) {
  return (
    <ListItemButton data-test-id="CurrentOrgBanner" title={name} disabled={switching} onClick={onSelect}>
      <ListItemText primary={name} primaryTypographyProps={PRIMARY_TYPOGRAPHY_PROPS} />
      <Chip label="Current" size="small" color="primary" variant="soft" />
    </ListItemButton>
  );
}

CurrentOrgBanner.propTypes = {
  name: pt.string.isRequired,
  switching: pt.bool,
  onSelect: pt.func.isRequired,
};
